<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Listas de Acuerdos</h1>
      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area">
            <div class="row new-row">
              <div class="col-4">
                <h2>Acuerdos del día</h2>
              </div>
            </div>
            <div class="row new-row">
              <div class="col-3">
                <input type="date" class="form-control" v-model="listaDeAcuerdosSubidor.fechaDeDictado">
              </div>
              <div class="col-3">
                <input type="button" value="Buscar" class="form-control" @click="obtenerAcuerdosDelDia">
              </div>
            </div>
            <hr />
            <div>
              <VistaPreviaListaDeAcuerdos
                :key="acuerdosKey"
                :prop_listaDeAcuerdos="listaDeAcuerdos"
                :prop_fechaDeDictado="listaDeAcuerdosSubidor.fechaDeDictado"
              ></VistaPreviaListaDeAcuerdos>
            </div>
            <div>
              <SubidorDeListaDeAcuerdos :prop_listaDeAcuerdos="listaDeAcuerdosSubidor" :key="acuerdosKey"></SubidorDeListaDeAcuerdos>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import enumeraciones from "@/../static/js/enumeraciones";
import catalogos from "@/../static/js/catalogos";
import api from "@/../static/js/api";
import comun from "@/../static/js/comun";
import axios from "axios";
import store from "@/store/index";
import DatosGenerales from "@/components/SIFA/AtencionDenuncias/RegistroDeDenuncia/DatosGenerales.vue";
import DatosFinales from "@/components/SIFA/AtencionDenuncias/RegistroDeDenuncia/DatosFinales.vue";
import VistaPreviaListaDeAcuerdos from "@/components/SIFA/Reportes/ListasDeAcuerdos/VistaPreviaListaDeAcuerdos.vue";
import SubidorDeListaDeAcuerdos from "@/components/SIFA/Reportes/ListasDeAcuerdos/SubidorDeListaDeAcuerdos.vue";
import { Acuerdo } from "@/components/SIFA/Comun/Modelos/Acuerdo.js";
import { ListaDeAcuerdos } from "@/components/SIFA/Comun/Modelos/ListaDeAcuerdos.js";
export default {
  data() {
    return {
      listaDeAcuerdos: [],
      listaDeAcuerdosSubidor: new ListaDeAcuerdos(),
      acuerdosKey: 0
    };
  },
  props: {},
  components: {
    VistaPreviaListaDeAcuerdos,
    SubidorDeListaDeAcuerdos
  },
  methods: {
    obtenerAcuerdosDelDia: function () {
      //Retorna una lista de citas 'Aceptadas'
      var peticion = {
        dia: this.listaDeAcuerdosSubidor.fechaDeDictado,
        conListaDeAcuerdo: false
      };
      console.log(peticion)
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SIFA.funciones.ObtenerAcuerdosDelDia,
          peticion /*, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)*/
        )
        .then((response) => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {
            //En caso de que la petición sea exitosa
            this.listaDeAcuerdos = response.data.AcuerdosDelDia
              ? response.data.AcuerdosDelDia.map((acuerdoObject) => {
                  let acuerdo = new Acuerdo();
                  acuerdo.constructorObjeto(acuerdoObject);
                  return acuerdo;
                })
              : [];
              this.listaDeAcuerdosSubidor.acuerdos = this.listaDeAcuerdos;
            this.acuerdosKey++;
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
    obtenerFechaAyer() {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      this.listaDeAcuerdosSubidor.fechaDeDictado = yesterday.toISOString().split("T")[0];
      this.listaDeAcuerdosSubidor.fechaDePublicacion = today.toISOString().split("T")[0];
    },
  },
  mounted: function mounted() {
    this.obtenerFechaAyer();
    this.obtenerAcuerdosDelDia();
  },
  computed: {},
};
</script>

<style scoped>
span {
  font-weight: bold;
}
b {
  padding-right: 3px;
}

.new-row {
  margin-top: 20px;
}

.fas {
  cursor: pointer;
}
.tab {
  overflow: hidden;
  padding-left: 15px;
}

/* Style the buttons inside the tab */
.tab button {
  background-color: #45454c;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
  font-size: 17px;
  color: whitesmoke;
  border-right: 1px solid #ccc;
  width: 20vw;
}

/* Change background color of buttons on hover */
.tab button:hover {
  background-color: #ddd;
  color: #000;
}

/* Create an active/current tablink class */
.tab button.active {
  background-color: #ccc;
  color: #000;
  font-weight: bolder;
}
.bigtextarea {
  height: 100px;
}
</style>





// WEBPACK FOOTER //
// src/components/SIFA/Reportes/ListasDeAcuerdos/ListasDeAcuerdos.vue